import React from "react";
import { m as motion } from "../../../shared/components/Motion";
import { ToggleSwitch } from "shared/components";
import { childVariants } from "shared/utils";

/**
 * AdminModeToggle Component
 * Displays toggle switch for enabling/disabling edit mode
 */
const AdminModeToggle = ({ adminMode, toggleAdminMode }) => {
  return (
    <motion.div
      className="themes__section"
      initial="hidden"
      animate="visible"
      exit="exit"
      variants={childVariants}
    >
      <div className="themes__model-content">
        <ToggleSwitch
          id="adminModeToggle"
          modelTitle={adminMode ? "Disable Edit Mode" : "Enable Edit Mode"}
          checked={adminMode}
          onChange={toggleAdminMode}
          icons={["bx bx-lock", "bx bx-edit"]}
        />
      </div>
    </motion.div>
  );
};

export default AdminModeToggle;
